<template>
  <div v-if="all" class="pr-10">
    <v-row class="pa-5">
      <v-col cols="12">
        <v-switch v-model="showRaw" label="Show Raw data" color="amber" class="mr-3" inset></v-switch>
      </v-col>
    </v-row>
    <SaveCanvas v-if="!showRaw" class="pl-5">
      <v-row class="pa-5">
        <v-col cols="12">
          <h2>{{ questionModel.title }}</h2>
        </v-col>
      </v-row>
      <v-row class="pa-5" v-for="(row, index) in answers" :key="row.tile">
        <v-col cols="12">
          <div class="divider"></div>
        </v-col>
        <v-col cols="3">
          <h3>{{ row.title }}</h3>
        </v-col>
        <v-col cols="9">
          <v-chip v-for="tag in row.answers" :key="`${row.title}-${tag.id}`" :class="colors[index]" class="ma-1">
            {{ tag.title }}
          </v-chip>
        </v-col>
      </v-row>
    </SaveCanvas>

    <SaveCanvas v-if="showRaw" class="pl-5">
      <v-row class="pa-5">
        <v-col cols="12">
          <h2>{{ questionModel.title }}</h2>
        </v-col>

      </v-row>
      <v-row class="pl-5 pr-5 pt-5" v-for="(row) in answers" :key="row.tile">
        <v-col cols="3">
          <h3>{{ row.title }}</h3>
        </v-col>
        <v-col cols="9">
          <p v-for="tag in row.answers" :key="`${row.title}-${tag.id}`" class="">
            {{ tag.title }}
          </p>
        </v-col>
        <v-col cols="12">
          <div class="divider"></div>
        </v-col>
      </v-row>

    </SaveCanvas>
  </div>
</template>

<script>
// import lodash from "lodash";

import { mapState } from "vuex";
import { SaveCanvas } from "@/components/core";

export default {
  name: "ResultsArhitectureSummary",
  components: {
    SaveCanvas,
  },
  props: {
    all: {
      type: Array,
      default: () => [],
    },
    questionModel: {
      type: Object,
      default: () => ({}),
    },
    audienceQuestions: {
      type: Array,
      default: () => [],
    },
    contentQuestions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showRaw: false,
    colors: [
      "indigo",
      "blue",
      "deep-purple",
      "green",
      "pink",
      "purple",
      "light-blue",
      "light-green",
    ],
  }),
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    answers() {
      const model = this.questionModel.model.split(".");
      return this.all.map((x) => {
        return {
          title: x.doc.title,
          answers: x.doc[model[0]][model[1]],
        };
      });
    },
  },
};
</script>

<style lang="scss">
.divider {
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 1);
}
</style>
